import { QueryClient } from '@tanstack/react-query';

// avoid dep cycle
import { isAbortError } from '@/api/fetch-client/util/abort-error.util';
import { ApiError } from '@/api/model';

const NO_RETRY_STATUSES = [400, 401, 403, 404];

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,

      retry: (failureCount, error) => {
        if (isAbortError(error)) {
          return false;
        }

        const status = (error as ApiError)?.response?.status;

        if (status && NO_RETRY_STATUSES.includes(status)) {
          return false;
        }

        return failureCount < 2;
      },
    },
  },
});
